import { SIGNIN_SUCCESS, LOGOUT, SET_ERROR, CLEAR_ERROR,  CLEAR_MSG, SET, GET_ALL_USERS, GET_DASHBOARD_METRICS, CREATE_USER, UPDATE_ADMIN_CREDENTIALS, GET_ALL_APPOINTMENTS, DELETE_USER, DELETE_APPOINTMENTS, GET_ALL_DOCTORS, GET_ALL_PATIENTS, GET_SPECIALITY, DELETE_SPECIALITY, EDIT_SPECIALITY} from './types';

export  const signInSuccess = (payLoadData) => ({
  type: SIGNIN_SUCCESS, // Updated usage
  payload: payLoadData,
});

export const getAllUsers = (payloadData) => ({
  type: GET_ALL_USERS,
  payload: payloadData
})

export const createUser = (payloadData) => ({
  type: CREATE_USER,
  payload: payloadData
})

export const deleteUser = (payloadData) => ({
  type: DELETE_USER,
  payload: payloadData
})


export const getAllAppointments = (payloadData) => ({
  type:GET_ALL_APPOINTMENTS,
  payload:payloadData
})

export const deleteAppointments = (payLoadData) => ({
  type:DELETE_APPOINTMENTS,
  payload:payLoadData
})

export const updateAdminCredentials = (payloadData) => ({
  type: UPDATE_ADMIN_CREDENTIALS,
  payload:payloadData
})

export const getDashboardMetrics = (payloadData) => ({
   type: GET_DASHBOARD_METRICS,
   payload: payloadData
})

export const fetchAllDoctorsRecords = (payLoadData) => ({
    type: GET_ALL_DOCTORS, // Updated usage
    payload: payLoadData,
});

export const getAllPatientsInfo = (payloadData) => ({
    type: GET_ALL_PATIENTS,
    payload: payloadData
  })

  export const addSpecialities = (payLoadData) => ({
    type: ADD_SPECIALITY, // Updated usage
    payload: payLoadData,
  });
  
  export const fetchAllSpecialities = (payLoadData) => ({
    type: GET_SPECIALITY,
    payload: payLoadData,
  });
  
  export const deleteSpeciality = (payLoadData) => ({
    type: DELETE_SPECIALITY,
    payload: payLoadData,
  })
  
  export const editSpeciality = (payLoadData) => ({
    type: EDIT_SPECIALITY,
    payload: payLoadData,
  })

export const setSidebarVisibility = (data) => ({
   type: SET,
   payload: data
})

export const logout = () => ({
  type: LOGOUT,
});

export const setError = (err) => ({
  type: SET_ERROR,
  payload: err,
});
export const clearError = () => ({
  type: CLEAR_ERROR,
});
export const clearMsg = () => ({
  type: CLEAR_MSG,
});
